import { Row } from '@cdab/scania/qpr/components'
import { TdsButton, TdsMessage } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 8px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 8px;
    margin-bottom: 4px;
  }
`
export const StyledFirstButton = styled(TdsButton)`
  padding-right: 8px;
`
export const StyledButton = styled(TdsButton)`
  flex: 0.13;
  padding-right: 8px;
`

export const StyledMessage = styled(TdsMessage)`
  flex: auto;
`

export const Title = styled.h3.attrs({
  className: 'tds-headline-03'
})`
  margin-bottom: 8px;
  margin-top: 8px;
`

export const ButtonMessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 16px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 12px;
  }
`
